import { DeliverableStage } from '@maxus/common'

import { MaxusChip } from './chip'

const chipStyles: Record<DeliverableStage, string> = {
  Demo: 'border-transparent bg-surface-active text-text-secondary',
  'A-Copy': 'border-transparent bg-[#243659] text-[#8bb7ff]',
  'B-Copy': 'border-transparent bg-[#2d2368] text-[#a59bff]',
  Master: 'border-transparent bg-[#3a2a12] text-[#f0b866]',
  Distribution: 'border-transparent bg-[#123524] text-[#5fe08a]',
}

export const StageChip = ({ stage }: { stage: DeliverableStage }) => {
  return <MaxusChip className={chipStyles[stage]}>{stage}</MaxusChip>
}
